module.exports = __webpack_public_path__ + "img/thermometer-title-m.ad713496.png";